import Yup from '_zari/validation/_yup'

export const ValidationSchema = Yup.object().shape({
  nombre: Yup.string()
    .min(2)
    .max(50)
    .required(),
  telefono1: Yup.string()
    .min(5)
    .max(15)
    .notRequired(),
  telefono2: Yup.string()
    .min(5)
    .max(15)
    .notRequired(),
  email1: Yup.string()
    .min(3)
    .max(150)
    .email()
    .notRequired(),
  email2: Yup.string()
    .min(3)
    .max(150)
    .email()
    .notRequired(),
  comentario: Yup.string()
    .min(5)
    .max(500)
    .notRequired()
})
